import React, { FC, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Button, DrawerBody, DrawerFooter, DrawerHeader, Heading, Input, Select, Stack, Text } from '@chakra-ui/react'

import { FormItem } from 'components'
import { useCustomFormCommonEntityPropsManager } from '../../contexts/CustomFormCommonEntityPropsManager/Provider'
import { CustomFormCommonEntityFilter } from '../../types'
import { focusElementById } from 'utils/events'
import CustomFormFilterWarningAlert from '../../../CustomFormFilterWarningAlert'

type Props = {
  onClose: () => void
}

const STATES: string[] = [
  'Acre',
  'Alagoas',
  'Amapá',
  'Amazonas',
  'Bahia',
  'Ceará',
  'Distrito Federal',
  'Espírito Santo',
  'Goiás',
  'Maranhão',
  'Mato Grosso',
  'Mato Grosso do Sul',
  'Minas Gerais',
  'Pará',
  'Paraíba',
  'Paraná',
  'Pernambuco',
  'Piauí',
  'Rio de Janeiro',
  'Rio Grande do Norte',
  'Rio Grande do Sul',
  'Rondônia',
  'Roraima',
  'Santa Catarina',
  'São Paulo',
  'Sergipe',
  'Tocantins',
]

const SearchEntityOnCustomForm: FC<Props> = ({ onClose }) => {
  const { handleSubmit, reset, register } = useForm<CustomFormCommonEntityFilter>({ defaultValues: { name: '' } })

  const { currentEntity, setView, filter, setFilter, setLoadingEntities } = useCustomFormCommonEntityPropsManager()

  const entityKey = currentEntity?.key

  function onSubmit(entityFilter: CustomFormCommonEntityFilter) {
    setFilter({ ...filter, ...entityFilter })
    setLoadingEntities(true)
    setView('SELECT_ENTITY')
  }

  useEffect(() => {
    focusElementById('name')
    reset({ name: filter.name || '' })
  }, [])

  return (
    <>
      <DrawerHeader>
        <Text>Selecionar {currentEntity.label}</Text>
        <Heading color="primary">Pesquisar {currentEntity.labelPlural}</Heading>
      </DrawerHeader>

      <DrawerBody>
        <Stack spacing={4}>
          <CustomFormFilterWarningAlert />

          <FormItem label="Nome" htmlFor="name">
            <Input id="name" {...register('name')} />
          </FormItem>

          {entityKey == 'city' && (
            <FormItem label="Estado" htmlFor="state">
              <Select id="state" defaultValue={''} {...register('state_name')}>
                <option value={''}>Todos os estados</option>
                {STATES.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </Select>
            </FormItem>
          )}
        </Stack>
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={onClose}>
          Fechar
        </Button>

        <Button onClick={() => handleSubmit(onSubmit)()}>Buscar {currentEntity.label}</Button>
      </DrawerFooter>
    </>
  )
}

export default SearchEntityOnCustomForm
